import { useAdministrationContext } from '@openx/components-administration/lib/utils/context/AdministrationContext';
import type { InventoryListByIdAPI } from '@openx/types/inventoryList';
import type { RowActionProps } from '@openx/types/tableHelpers';
import { sortMenuButtonItems } from '@openx/utils/lib/tableHelpers';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { downloadInventoryList } from '../../utils/downloadInventoryList/downloadInventoryList';

export const useInventoryListsRowActions = (): RowActionProps<InventoryListByIdAPI>[] => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { useDeleteInventoryList } = useAdministrationContext();
  const { deleteInventoryList } = useDeleteInventoryList();

  return useMemo(
    () =>
      sortMenuButtonItems({
        DOWNLOAD: {
          label: t('Download'),
          'data-test': 'download',
          onClick: inventoryList => {
            downloadInventoryList(inventoryList);
          },
        },
        DELETE: {
          danger: true,
          label: t('Delete'),
          'data-test': 'delete',
          onClick: async ({ id, name }) => {
            if (!id || !name) return;

            await deleteInventoryList({ id, name });
          },
        },
        EDIT: {
          label: t('Edit'),
          'data-test': 'edit',
          onClick: ({ id }) => {
            navigate(`/inventory-lists/${id}/edit`);
          },
        },
        DETAILS: {
          label: t('Details'),
          'data-test': 'details',
          onClick: ({ id }) => {
            navigate(`/inventory-lists/${id}/details`);
          },
        },
      }),
    [navigate, t, deleteInventoryList]
  );
};
